import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=74a06acc&scoped=true&"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmation.vue?vue&type=style&index=0&id=74a06acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a06acc",
  null
  
)

/* custom blocks */
import block0 from "./OrderConfirmation.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "OrderConfirmation.vue"
export default component.exports